module.exports = __webpack_public_path__ + "img/cep_logotipo_full_white.5fb0dcb6.png";